import React, {FC, useEffect, useState} from 'react'
import {apiUrlWithStore} from '../../helper'
import {NextRouter, useRouter} from 'next/router'
import {CheckToastSvg, FailSvg} from '../../svg'
import {useToast} from "../../atoms/Toast/useToast";
import {CustomTextField} from "../../atoms"
import {loginPageFormType} from "./types";
import TextField from "../../atoms/customFields/TextField";
import TextArea from "../../atoms/customFields/TextArea";
import DropDown from "../../atoms/customFields/DropDown";
import DateField from "../../atoms/customFields/DateField";
import YesNoRadio from "../../atoms/customFields/YesNoRadio";
import RadioButton from "../../atoms/customFields/RadioButton";
import SelectField from "../../atoms/customFields/SelectField";
import cls from "./account.module.scss"
import {useReCaptcha} from "next-recaptcha-v3";
import {spaceToUpperCaseConvertor} from "../../services/utils";
import PageHeader from "../shared/PageHeader";
import {TranslationsType} from "../../types/homePageTypes";

interface IProps {
    breadcrumb: Array<{ title: string; url: string }>;
    customFieldGenerate: any;
    translationsData: TranslationsType;
    recaptchaActive: string
    dbName: string
}

const AccountPageLogin: FC<IProps> = (
    {
        breadcrumb,
        customFieldGenerate,
        translationsData,
        recaptchaActive,
        dbName
    }
) => {
    const [savedFormData, setSavedFormData] = useState<loginPageFormType>({
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        first_name: "",
        last_name: "",
        re_token: "",
    })

    const [formErrors, setFormErrors] = useState<loginPageFormType>({
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        re_token: "",
    })
    const [urlValidate, setUrlValidate] = useState(true);
    const [isSubmitted, setIsSubmitted] = useState(false)
    const history: NextRouter = useRouter()
    const toast = useToast();
    const {executeRecaptcha} = useReCaptcha();


    const handleChange = (event: React.FormEvent<HTMLInputElement>, code?: string) => {
        const {name, value} = (event.target as HTMLInputElement);
        const regexDecimal = /^\d+(\.\d{0,100})?$/
        const regexInteger = /^\d+$/
        const regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
        const regexLettersOnly = /^[a-zA-Z]+$/
        const regexLettersAndNumbersOnly = /^[a-zA-Z0-9]+$/
        const filterValue = () => {
            if (code === "decimal" && !regexDecimal.test(value)) {
                if (regexDecimal.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "integer" && !regexInteger.test(value)) {
                if (regexInteger.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "url") {
                setUrlValidate(value !== "" ? regexUrl.test(value) : true);
            }
            if (code === "letter" && !regexLettersOnly.test(value)) {
                if (regexLettersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }

            if (code === "letter_number" && !regexLettersAndNumbersOnly.test(value)) {
                if (regexLettersAndNumbersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            return value
        }

        setSavedFormData({...savedFormData, [name]: filterValue()})
    }

    const handleSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault()
        if (String(recaptchaActive) === "1") {
            const token = await executeRecaptcha("form_submit");
            setSavedFormData({...savedFormData, re_token: token})
        }
        setIsSubmitted(true)
        setFormErrors(validate(savedFormData) as loginPageFormType)
    }

    const validate = (form: loginPageFormType) => {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        const regexDecimal = /^\d+(\.\d+)?$/
        const regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
        let errors = {}

        const attributeCode = (name: string) => {
            return customFieldGenerate
                .map((item: { validation: string }) => {
                    if (item.validation === name) {
                        return item
                    }
                })
                .filter((item: any) => item !== undefined)
                .map((elem: { attribute_code: string }) => elem.attribute_code)
        }
        if (!form.email) {
            (errors as loginPageFormType).email = "This email is required";
        }
        if (!form.password_confirmation || form.password != form.password_confirmation) {
            (errors as loginPageFormType).password_confirmation = "Passwords do not match";
        }

        if (!form.email || !regexEmail.test(form.email)) {
            (errors as loginPageFormType).invalidEmail = "Invalid email format";
        }
        attributeCode("decimal").map((el: string) => {
            if (!(form as Record<string, string>)[el] || !regexDecimal.test((form as Record<string, string>)[el])) {
                (errors as Record<string, string>)[el] = "Please enter a valid decimal number";
            }
        })
        attributeCode("url").map((el: string) => {
            if (!(form as Record<string, string>)[el] || !regexUrl.test((form as Record<string, string>)[el])) {
                (errors as Record<string, string>)[el] = "Invalid Url format";
            }
        })

        if (!form.password || form.password.length < 6) {
            (errors as loginPageFormType).password = "Password must be more than 6 characters";
        }

        return errors
    }

    useEffect(() => {
        if (!Object.keys(formErrors).length && isSubmitted) {
            registerHandler()
            setIsSubmitted(false)
        }
    }, [formErrors])

    const registerHandler = () => {

        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(savedFormData),
        }

        fetch(apiUrlWithStore('/api/customer/register'), options)
            .then((responce) => responce.json())
            .then((res) => {

                if (res.message == 'Your account has been created successfully.') {
                    history.push('/')
                    toast.open(
                        <span className="d-flex chek-fms">
                            <CheckToastSvg/>
                            {translationsData.AccountCreateSuccess}
                        </span>
                    )
                } else if (res.message == 'Verification mail sent.') {
                    history.push('/')
                    toast.open(
                        <span className="d-flex chek-fms">
                            <CheckToastSvg/>
                            {translationsData.VerificationMailToast}
                        </span>
                    )
                } else {
                    if (res.email) {
                        toast.open(
                            <span className="d-flex chek-fms">
                                <FailSvg/>
                                {translationsData[spaceToUpperCaseConvertor(res.email[0])]}
                            </span>
                        )
                    }
                }
            })
    }

    return (
        <div className="page">
            <PageHeader dbName={dbName} breadcrumb={breadcrumb}/>
            <div>
                <div className="container">
                    <div className={`${cls["card-wrapper"]} ${cls["create_an_account"]}`}>
                        <div className={cls.card}>
                            <div className={cls["card-body"]}>
                                <h1 className={cls["card-title"]}>
                                    {translationsData.SignUp}
                                </h1>
                                <form onSubmit={handleSubmit}>
                                    {customFieldGenerate.map((item: any, index: number) => {
                                        switch (item.type) {
                                            case "textfield":
                                                if (item.attribute_code === 'contactpersonphonenumber') {
                                                    return null;
                                                } else if ((item.attribute_code === 'contactpersonemail')) {
                                                    return null
                                                } else {
                                                    return (
                                                        <TextField
                                                            item={item}
                                                            index={index}
                                                            savedFormData={savedFormData}
                                                            translationsData={translationsData}
                                                            handleChange={handleChange}
                                                            formErrors={formErrors}
                                                            urlValidate={urlValidate}
                                                        />
                                                    );
                                                }
                                            case "textarea":
                                                return <TextArea
                                                    item={item}
                                                    index={index}
                                                    translationsData={translationsData}
                                                    savedFormData={savedFormData}
                                                    handleChange={
                                                        handleChange as unknown as
                                                            (event: {
                                                                target: { value: string, name?: string }
                                                            }, item: string) => void
                                                    }
                                                />
                                            case "dropdown":
                                                return <DropDown
                                                    item={item}
                                                    index={index}
                                                    translationsData={translationsData}
                                                    savedFormData={savedFormData}
                                                    handleChange={handleChange}
                                                />
                                            case "date":
                                                return <DateField
                                                    item={item}
                                                    index={index}
                                                    savedFormData={savedFormData}
                                                    translationsData={translationsData}
                                                    handleChange={handleChange}
                                                />
                                            case "boolean":
                                                return <YesNoRadio
                                                    item={item}
                                                    index={index}
                                                    translationsData={translationsData}
                                                    handleChange={handleChange}
                                                />
                                            case "radio":
                                                return <RadioButton
                                                    item={item}
                                                    index={index}
                                                    translationsData={translationsData}
                                                    handleChange={handleChange}
                                                />
                                            case "multiselect":
                                                return <SelectField
                                                    item={item}
                                                    index={index}
                                                    translationsData={translationsData}
                                                    handleChange={
                                                        handleChange as unknown as (
                                                            event: {
                                                                target: {
                                                                    value: string;
                                                                    name?: string | undefined;
                                                                };
                                                            }, item: string
                                                        ) => void
                                                    }
                                                />
                                        }
                                    })}
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            inpValue={savedFormData.phone}
                                            name="phone"
                                            handleChange={(e) => handleChange(e, "integer")}
                                            value={translationsData.Phone}
                                        />
                                    </div>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            inpValue={savedFormData.email}
                                            name="email"
                                            handleChange={handleChange}
                                            value={translationsData.Email}
                                        />
                                        <div className="alert alert-danger p-0 m-0">
                                            {
                                                formErrors?.email ?
                                                    translationsData.TheEmailFieldIsRequired
                                                    : formErrors?.invalidEmail ?
                                                        translationsData.InvalidEmailFormat
                                                        : ""
                                            }
                                        </div>
                                    </div>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            type="password"
                                            name="password"
                                            inpValue={savedFormData.password}
                                            handleChange={handleChange}
                                            value={translationsData.Password}
                                        />

                                        <div className="alert alert-danger p-0 m-0">
                                            {
                                                formErrors?.password &&
                                                translationsData.CharactersPassword
                                            }
                                        </div>
                                    </div>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            type="password"
                                            name="password_confirmation"
                                            inpValue={savedFormData.password_confirmation}
                                            handleChange={handleChange}
                                            value={translationsData.ConfirmPassword}
                                        />
                                        <div className="alert alert-danger p-0 m-0">
                                            {formErrors?.password_confirmation &&
                                                translationsData.PasswordsAreNotTheSame
                                            }
                                        </div>
                                    </div>
                                    <div
                                        className={cls["signUp-contact_person"]}>{translationsData.ContactPerson + ":"}</div>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            type="text"
                                            name="first_name"
                                            inpValue={savedFormData.first_name}
                                            handleChange={handleChange}
                                            value={translationsData.FirstName}
                                        />
                                    </div>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            type="text"
                                            name="last_name"
                                            inpValue={savedFormData.last_name}
                                            handleChange={handleChange}
                                            value={translationsData.LastName}
                                        />
                                    </div>
                                    {customFieldGenerate.map((item: any, index: number) => {
                                        switch (`${item.type}-${item.attribute_code}`) {
                                            case "textfield-contactpersonemail":
                                                return <TextField
                                                    item={item}
                                                    index={index}
                                                    savedFormData={savedFormData}
                                                    translationsData={translationsData}
                                                    handleChange={handleChange}
                                                    formErrors={formErrors}
                                                    urlValidate={urlValidate}
                                                />
                                            case "textfield-contactpersonphonenumber":
                                                return <TextField
                                                    item={item}
                                                    index={index}
                                                    savedFormData={savedFormData}
                                                    translationsData={translationsData}
                                                    handleChange={handleChange}
                                                    formErrors={formErrors}
                                                    urlValidate={urlValidate}
                                                />
                                        }
                                    })}
                                    <button
                                        type="submit"
                                        className={`btn btn-lg btn-orange ${cls["login-button"]} ${["rounded-pills"]}  ${cls.sbm_button}`}
                                    >
                                        {translationsData.SignUp}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AccountPageLogin;